import React from 'react'

const Footer = () => {
  return (
    <div style={{flexBasis:'2%'}} className='text-center bg-blac'>All Rights Reserved © {new Date().getFullYear()}</div>
  )
}

export default Footer